module.exports = __webpack_public_path__ + "img/somaliland.e08f14f8.svg";